<template>
  <main-layout :selectedMenu="'download'">
    <p>APP{{$t('global.下载')}}</p>
  </main-layout>
</template>

<script>
  import MainLayout from "@/layouts/MainLayout"

  export default {
    metaInfo () {
      return {
        title: this.$t('global.下载页') + " | MANA"
      }
  },
    components: {
      MainLayout
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Download.vue